export const prevArrow = `
    <div class="slider__prev w-[55px] h-[55px] hover:cursor-pointer">
        <svg class="rotate-180" xmlns="http://www.w3.org/2000/svg" width="78" height="78" viewBox="0 0 78 78">
  <g data-name="Group 120" transform="translate(-1198 -1799)">
    <rect data-name="Rectangle 12" width="78" height="78" rx="39" transform="translate(1198 1799)" fill="currentColor"/>
    <path data-name="Path 6" d="m1231.946 1827.893 10.107 10.107-10.107 10.107" fill="none" stroke="#fff"/>
  </g>
</svg>
    </div>`;
export const nextArrow = `
    <div class="slider__next w-[55px] h-[55px] hover:cursor-pointer">
        <svg xmlns="http://www.w3.org/2000/svg" width="78" height="78" viewBox="0 0 78 78">
  <g data-name="Group 120" transform="translate(-1198 -1799)">
    <rect data-name="Rectangle 12" width="78" height="78" rx="39" transform="translate(1198 1799)" fill="currentColor"/>
    <path data-name="Path 6" d="m1231.946 1827.893 10.107 10.107-10.107 10.107" fill="none" stroke="#fff"/>
  </g>
</svg>
    </div>`;

export const options = {
    slidesToShow: 3,
    swipeToSlide: true,
    infinite: false,
    cssEase: 'ease',
    speed: 600,
    nextArrow,
    prevArrow
};

